// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ToneArchetypeRequiredModal — blocking overlay for existing users */

.tone-required-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.65);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.tone-required-modal {
    background: var(--card-bg, #ffffff);
    border-radius: 16px;
    padding: 2rem;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.tone-required-header {
    text-align: center;
}

.tone-required-header h2 {
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.tone-required-subtitle {
    color: var(--text-secondary, #6b7280);
    font-size: 0.95rem;
    max-width: 520px;
}

.tone-required-error {
    background: #fee2e2;
    color: #dc2626;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    width: 100%;
    text-align: center;
}

.tone-required-loading {
    display: flex;
    justify-content: center;
    padding: 2rem;
}

/* Reuse shared archetype-grid / archetype-card styles
   (same as ToneArchetypeStep.css — declare only if not globally available) */
.tone-required-modal .archetype-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    width: 100%;
}

@media (max-width: 640px) {
    .tone-required-modal .archetype-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 400px) {
    .tone-required-modal .archetype-grid {
        grid-template-columns: 1fr;
    }
}

.tone-required-modal .archetype-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    padding: 1rem;
    border: 2px solid var(--border-color, #e5e7eb);
    border-radius: 12px;
    background: transparent;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.1s;
}

.tone-required-modal .archetype-card:hover {
    border-color: var(--primary, #6366f1);
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
}

.tone-required-modal .archetype-card.selected {
    border-color: var(--primary, #6366f1);
    background: var(--primary-light, #eef2ff);
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
    transform: translateY(-1px);
}

.tone-required-modal .archetype-icon {
    font-size: 1.75rem;
    line-height: 1;
}

.tone-required-modal .archetype-label {
    font-weight: 700;
    font-size: 0.95rem;
    color: var(--text-primary, #111827);
}

.tone-required-modal .archetype-tagline {
    font-size: 0.82rem;
    color: var(--primary, #6366f1);
    font-style: italic;
}

.tone-required-modal .archetype-description {
    font-size: 0.78rem;
    color: var(--text-secondary, #6b7280);
    line-height: 1.4;
    margin-top: 0.15rem;
}

.tone-required-notice {
    font-size: 0.82rem;
    color: var(--text-secondary, #6b7280);
    text-align: center;
}

.tone-required-confirm {
    min-width: 220px;
}`, "",{"version":3,"sources":["webpack://./src/components/ToneArchetypeRequiredModal.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;6EAC6E;AAC7E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,8DAA8D;AAClE;;AAEA;IACI,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;IACzC,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* ToneArchetypeRequiredModal — blocking overlay for existing users */\n\n.tone-required-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.65);\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.tone-required-modal {\n    background: var(--card-bg, #ffffff);\n    border-radius: 16px;\n    padding: 2rem;\n    max-width: 800px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.tone-required-header {\n    text-align: center;\n}\n\n.tone-required-header h2 {\n    font-size: 1.6rem;\n    font-weight: 700;\n    margin-bottom: 0.5rem;\n}\n\n.tone-required-subtitle {\n    color: var(--text-secondary, #6b7280);\n    font-size: 0.95rem;\n    max-width: 520px;\n}\n\n.tone-required-error {\n    background: #fee2e2;\n    color: #dc2626;\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n    width: 100%;\n    text-align: center;\n}\n\n.tone-required-loading {\n    display: flex;\n    justify-content: center;\n    padding: 2rem;\n}\n\n/* Reuse shared archetype-grid / archetype-card styles\n   (same as ToneArchetypeStep.css — declare only if not globally available) */\n.tone-required-modal .archetype-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n    width: 100%;\n}\n\n@media (max-width: 640px) {\n    .tone-required-modal .archetype-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 400px) {\n    .tone-required-modal .archetype-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.tone-required-modal .archetype-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n    padding: 1rem;\n    border: 2px solid var(--border-color, #e5e7eb);\n    border-radius: 12px;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    transition: border-color 0.2s, box-shadow 0.2s, transform 0.1s;\n}\n\n.tone-required-modal .archetype-card:hover {\n    border-color: var(--primary, #6366f1);\n    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);\n}\n\n.tone-required-modal .archetype-card.selected {\n    border-color: var(--primary, #6366f1);\n    background: var(--primary-light, #eef2ff);\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);\n    transform: translateY(-1px);\n}\n\n.tone-required-modal .archetype-icon {\n    font-size: 1.75rem;\n    line-height: 1;\n}\n\n.tone-required-modal .archetype-label {\n    font-weight: 700;\n    font-size: 0.95rem;\n    color: var(--text-primary, #111827);\n}\n\n.tone-required-modal .archetype-tagline {\n    font-size: 0.82rem;\n    color: var(--primary, #6366f1);\n    font-style: italic;\n}\n\n.tone-required-modal .archetype-description {\n    font-size: 0.78rem;\n    color: var(--text-secondary, #6b7280);\n    line-height: 1.4;\n    margin-top: 0.15rem;\n}\n\n.tone-required-notice {\n    font-size: 0.82rem;\n    color: var(--text-secondary, #6b7280);\n    text-align: center;\n}\n\n.tone-required-confirm {\n    min-width: 220px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
